module.exports = __webpack_public_path__ + "img/karakters-6.61d427fc.jpg";